<template>
  <div class="inner-cell">
    <AnalysisRequestCouponCells
      v-if="scope === 'CouponSample'"
      :sampleAttribute="sampleAttribute"
      :analysisRequest="analysisRequest"
      :updateAnalysisRequest="updateAnalysisRequest"
      :updateCouponSample="updateCouponSample"
      :updateSampleFile="updateSampleFile"
      :isSummaryView="isSummaryView"
      :standardFamilyList="standardFamilyList"
      :analysisRequestStandards="analysisRequestStandards"
      :sampleId="sampleId"
      :couponList="couponList"
    />
    <AnalysisRequestDepositCells
      v-else-if="scope === 'DepositSample'"
      :sampleAttribute="sampleAttribute"
      :analysisRequest="analysisRequest"
      :analysisRequestId="analysisRequestId"
      :updateAnalysisRequest="updateAnalysisRequest"
      :updateSampleFile="updateSampleFile"
      :isSummaryView="isSummaryView"
      :depositCompositionList="depositCompositionList"
      :updateSample="updateSample"
      :sampleObj="sample"
    />
    <AnalysisRequestContenanceCells
      v-else-if="scope === 'ContenanceSample'"
      :sampleAttribute="sampleAttribute"
      :analysisRequest="analysisRequest"
      :updateAnalysisRequest="updateAnalysisRequest"
      :isSummaryView="isSummaryView"
      :updateSample="updateSample"
    />
    <!-- we have ONE sample per Analysis request -->
    <div v-else>
      <div>
        <div v-if="sampleAttribute === 'sampleComment'">
          <div>
            <VTextarea
              v-model="sample.comment"
              :readonly="isSummaryView"
              outlined
              :hideDetails="true"
              :rules="{ max: 50 }"
              data-cy="cell-sampleComment"
              class="sampleInput--textarea"
              dense
              @input="updateSample($event, 'comment', analysisRequest, sample.id)"
            />
          </div>
        </div>

        <div v-if="sampleAttribute === 'labId'">
          <div>
            <VTextField
              v-model="sample.labId"
              :readonly="isSummaryView"
              outlined
              data-cy="cell-labID"
              hideDetails
              dense
              @input="updateSample($event, 'labId', analysisRequest, sample.id)"
            />
          </div>
        </div>
        <div v-else-if="sampleAttribute === 'type'">
          {{ $t(`analysisRequests.labels.template.sampleTypes.${analysisRequest.type.toLowerCase()}`) }}
        </div>
        <div
          v-else-if="sampleAttribute === 'samples'"
          style="width:222px"
        >
          <span>
            {{ sample.identification }}
          </span>
        </div>
        <div v-else-if="sampleAttribute === 'networkType'">
          {{ analysisRequest.networkType.name }}
        </div>
        <div v-else-if="sampleAttribute === 'componentType'">
          {{ analysisRequest.component.type.name }}
        </div>
        <div
          v-else-if="sampleAttribute === 'applicableNorms'"
        >
          <VSelect
            v-model="analysisRequest[sampleAttribute]"
            :items="standardFamilyList"
            :disabled="isSummaryView"
            outlined
            hideDetails
            data-cy="WorkOrder-Standard"
            dense
            @input="updateAnalysisRequest(sampleAttribute, $event, analysisRequest, null)"
          />
        </div>
        <div
          v-else-if="sampleAttribute === 'collectedDate'"
        >
          <VDateTimePicker
            v-model="sample.collectedDate"
            :disabled="isSummaryView"
            :locale="datePickerLocales[$store.getters.lang]"
            hideDetails
            prependInnerIcon="event"
            outlined
            style="width: 230px;"
            data-cy="collectedDateWO"
            dense
            :format="'L LT'"
            @input="updateAnalysisRequest(sampleAttribute, {value: moment($event), id: sample.id }, analysisRequest, null, true)"
          />
        </div>
        <div
          v-else-if="sampleAttribute === 'receivedDate'"
        >
          <VDateTimePicker
            v-model="sample.receivedDate"
            :disabled="isSummaryView"
            :locale="datePickerLocales[$store.getters.lang]"
            hideDetails
            prependInnerIcon="event"
            outlined
            style="width: 230px;"
            :format="'L LT'"
            data-cy="receivedDateWO"
            dense
            @input="updateAnalysisRequest(sampleAttribute, {value: moment($event), id: sample.id }, analysisRequest, null, true)"
          />
        </div>
        <div
          v-else-if="sampleAttribute === 'glycolType'"
        >
          <VSelect
            v-model="analysisRequest.glycolType"
            :label="$t('forms.labels.type')"
            :items="displayedGlycol"
            :disabled="isSummaryView"
            :hideDetails="true"
            itemValue="key"
            itemText="name"
            outlined
            data-cy="selectGlycol"
            dense
            @input="updateGlycolType( analysisRequest.id , analysisRequest.glycolType, analysisRequest)"
          />
        </div>
        <div v-else-if="sampleAttribute === 'treatment'">
          <VTextarea
            v-model="analysisRequest.treatment"
            hideDetails
            outlined
            dense
            @input="updateTreatment( analysisRequest.id , analysisRequest.treatment, analysisRequest)"
          />
        </div>
        <div
          v-else-if="sampleAttribute === 'plating'"
        >
          <VDatePicker
            v-model="sample.plating"
            :disabled="isSummaryView"
            :locale="datePickerLocales[$store.getters.lang]"
            hideDetails
            prependInnerIcon="event"
            outlined
            dense
            @input="updateAnalysisRequest(sampleAttribute, {value: moment($event), id: sample.id }, analysisRequest, null, true)"
          />
        </div>
        <div
          v-else-if="sampleAttribute === 'treatmentUsed'"
        >
          <VSelect
            v-model="sample.treatmentUsed"
            outlined
            :label="$t('labWorkOrderTable.labels.treatmentUsed')"
            :disabled="isSummaryView"
            itemValue="key"
            itemText="name"
            hideDetails
            :items="displayedTreatments"
            data-cy="treatmentUsed"
            dense
            @input="updateAnalysisRequest(sampleAttribute, {value: $event, id: sample.id }, analysisRequest, null, true)"
          />
        </div>
        <div
          v-else-if="sampleAttribute === 'expressionResult'"
        >
          <VSelect
            v-model="sample.expressionResult"
            outlined
            :label="$t('labWorkOrderTable.labels.expressionResult')"
            :disabled="isSummaryView"
            itemValue="key"
            itemText="name"
            hideDetails
            :items="displayedExpression"
            data-cy="expressionResult"
            dense
            @input="updateAnalysisRequest(sampleAttribute, {value: $event, id: sample.id }, analysisRequest, null, true)"
          />
        </div>
        <div
          v-else-if="sampleAttribute === 'resultInterpretation' && isSummaryView"
        >
          <div v-if="scope === sampleTypes.LEGIONELLOSIS || scope === sampleTypes.LEGIONELLA_CULTRURE">
            <div
              v-for="(standard, ARStandard) in analysisRequestStandards"
              :key="ARStandard"
              class="caption-item"
            >
              <LegionellaCaption
                :legionnelStandard="standard"
              />
            </div>
          </div>
          <div v-else-if="scope === sampleTypes.RESIN || scope === sampleTypes.WATER || scope === sampleTypes.GLYCOL">
            <div
              v-for="(standard, ARStandard) in analysisRequestStandards"
              :key="ARStandard"
              class="caption-item"
            >
              <StandardCaption
                :standard="standard"
              />
            </div>
          </div>
        </div>
        <div v-else>
          <v-tooltip bottom>
            <VTextarea
              v-model="analysisRequest[sampleAttribute]"
              :readonly="isSummaryView"
              outlined
              hideDetails
              dense
              @input="updateAnalysisRequest(sampleAttribute, $event, analysisRequest, null)"
            />
          </v-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect';
import VDateTimePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDateTimePicker';
import VDatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker';
import AnalysisRequestCouponCells from '@/views/laboratory/workOrder/AnalysisRequestCouponCells';
import AnalysisRequestContenanceCells from '@/views/laboratory/workOrder/AnalysisRequestContenanceCells';
import AnalysisRequestDepositCells from '@/views/laboratory/workOrder/AnalysisRequestDepositCells';
import LegionellaCaption from '@/views/laboratory/workOrder/summary/standardsInterpretation/LegionellaCaption';
import StandardCaption from '@/views/laboratory/workOrder/summary/standardsInterpretation/standards';
import sampleTypes from '@/constants/sampleTypes';
import _datePickerLocales from '@/locales/date-picker-locales';

export default {
    components: {
        AnalysisRequestDepositCells,
        AnalysisRequestContenanceCells,
        AnalysisRequestCouponCells,
        VTextField,
        VTextarea,
        VSelect,
        VDateTimePicker,
        LegionellaCaption,
        StandardCaption,
        VDatePicker,
    },
    props: {
        analysisRequest: {
            type: Object,
            default: () => ({}),
        },
        analysisRequestId: {
            type: String,
            default: '',
        },
        sampleObj: {
            type: Object,
            default: () => null,
        },
        depositCompositionList: {
            type: Array,
            default: () => ([]),
        },
        sampleAttribute: {
            type: String,
            default: '',
        },
        scope: {
            type: String,
            default: '',
        },
        updateAnalysisRequest: {
            type: Function,
            default: () => {},
        },
        updateCouponSample: {
            type: Function,
            default: () => {},
        },
        updateSampleFile: {
            type: Function,
            default: () => {},
        },
        updateTreatment: {
            type: Function,
            default: () => {},
        },
        updateGlycolType: {
            type: Function,
            default: () => {},
        },
        standardFamilyList: {
            type: Array,
            default: () => ([]),
        },
        isSummaryView: {
            type: Boolean,
            default: false,
        },
        analysisTypeList: {
            type: Array,
            default: () => ([]),
        },
        couponList: {
            type: Array,
            default: () => ([]),
        },
        updateSample: {
            type: Function,
            default: () => {},
        },
        glycolTypeList: {
            type: Array,
            default: () => ([]),
        },
        analysisRequestStandards: {
            type: Array,
            default: () => ([]),
        },
        sampleId: {
            type: String,
            required: true,
        },
    },
    data() {
        return { sampleTypes, sample: {} };
    },
    computed: {
        activeSamples() {
            return !this.sample ? [] : [this.sample].map(sample => ({
                ...sample,
                name: sample.identification || sample.id,
            })).filter(u => u.status !== 'REFUSED');
        },
        displayedTreatments() {
            return this.sampleAttribute === 'treatmentUsed' ? ['ACIDE', 'THERMIQUE', 'ALL', 'NONE'].map(key => ({
                name: this.$t(`labWorkOrderTable.labels.${key.toLowerCase()}`),
                key,
            })) : [];
        },
        displayedExpression() {
            return this.sampleAttribute === 'expressionResult' ? ['NONE', 'QUANTIFICA', 'DETECTION'].map(key => ({
                name: this.$t(`labWorkOrderTable.labels.${key.toLowerCase()}`),
                key: key === 'NONE' ? null : key,
            })) : [];
        },
        displayedGlycol() {
            return this.glycolTypeList.map(key => ({
                key,
                name: this.$t(`glycolTypes.${key}`),
            }));
        },
        datePickerLocales() {
            return _datePickerLocales;
        },
    },
    watch: {
        sampleObj: {
            handler() {
                this.sample = { ...this.sampleObj };
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        findStandard(aT, standard) {
            return (aT && standard.analysisType && aT.id === standard.analysisType.id);
        },
    },
};
</script>
<style lang="scss" scoped>
  .v-input__slot {
    background-color: red !important;
    width: 1500px !important
  }
  .inner-cell {
    width: 230px;
    margin-top: 0;
    padding-top: 0;
    // change color of the text inside blocs (div)
    color: #26384B;
  }
  .sample-chip {
    width: 230px !important;
  }
  ::v-deep .theme--light.v-input input, ::v-deep .v-textarea textarea, ::v-deep .theme--light.v-select .v-select__selection--comma {
    // change color of the text inside inputs, textareas, selects
    color: #26384B !important;
  }
  ::v-deep .v-textarea textarea {
    line-height: 15px !important;
  }
  ::v-deep .v-date-picker--inputHeight .v-icon.v-icon {
    // change color of the prepend icon of date picker
    color: #26384B !important;
  }
</style>
